import { render } from "./EditReview.vue?vue&type=template&id=f6d889a2&scoped=true"
import script from "./EditReview.vue?vue&type=script&lang=js"
export * from "./EditReview.vue?vue&type=script&lang=js"

import "./review.scss?vue&type=style&index=0&id=f6d889a2&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d889a2"]])

export default __exports__